import { NavigationExtras } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export enum Actions {
    Go = '[Router] Go'
}

export const RouterActions = {
    go: createAction(Actions.Go, props<{ path: any[]; query?: object; extras?: NavigationExtras }>())
};
